import React from 'react'
import { Helmet } from 'react-helmet'

/** Helmet Helper */
class HelmetHelper {
  /**
   * Adiciona o título
   * referente a página
   *
   * @param {string} prefixoDoTitulo
   * @returns {JSX.Element}
   */
  public static adicionaTituloDaPagina(prefixoDoTitulo?: string): JSX.Element {
    const sufixoBaseDoTitulo = `Agendamento de Consultas | Rede D'Or São Luiz`

    return (
      <Helmet>
        <title>
          {`${
            prefixoDoTitulo ? `${prefixoDoTitulo} - ` : ''
          }${sufixoBaseDoTitulo}`}
        </title>
      </Helmet>
    )
  }

  /**
   * Incorpora os scripts do HOTJAR
   * nas páginas da aplicação
   *
   * @returns {JSX.Element}
   */
  public static incorporaScriptsDoHotjar(): JSX.Element {
    const HOTJAR_ID = 2897522
    const UTM_SOURCE = 'tuasaude.com'

    const searchParams = new URLSearchParams(window.location.search)

    const temParametroValido =
      searchParams.has('utm_source') &&
      searchParams.get('utm_source') === UTM_SOURCE

    return temParametroValido ? (
      <Helmet>
        <script
          src={`https://static.hotjar.com/c/hotjar-${HOTJAR_ID}.js?sv=6`}
          async
        />
      </Helmet>
    ) : (
      <></>
    )
  }

  /**
   * Incorpora os scripts do LGPD
   * nas páginas da aplicação
   *
   * @returns {JSX.Element}
   */
  public static incorporaScriptsDoLgpd(): JSX.Element {
    return (
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.privacytools.com.br/public_api/banner/style/DPO41241.css?t=1"
        />
        <script
          type="text/javascript"
          src="https://cdn.privacytools.com.br/public_api/banner/script/DPO41241.js?p=bottom&t=1"
        />
      </Helmet>
    )
  }
}

export default HelmetHelper
